import {cn} from './cn'

/** Presentation only: date-time owns locale, zone and cross-day semantics. `timeFirst` leads with the hours; `align="start"` follows a left-aligned title. */
export function ActivityTerm({dateLabel, timeLabel, isCrossDay = false, timeFirst = false, align = 'center'}: {
    dateLabel: string; timeLabel: string; isCrossDay?: boolean; timeFirst?: boolean; align?: 'center' | 'start'
}) {
    const timeClassName = cn('font-semibold tabular-nums', !isCrossDay && 'whitespace-nowrap')
    // The separator stays with the second part when the line wraps.
    const separator = dateLabel ? <span aria-hidden="true" className="mr-2 font-normal">·</span> : null
    return <div data-activity-term className={cn('flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-1 text-base leading-6 text-gray-900 dark:text-gray-100', align === 'center' ? 'justify-center text-center' : 'justify-start text-left')}>
        {timeFirst ? <>
            <span className={timeClassName}>{timeLabel}</span>
            {dateLabel ? <span className="font-medium">{separator}{dateLabel}</span> : null}
        </> : <>
            {dateLabel ? <span className="font-medium">{dateLabel}</span> : null}
            <span className={timeClassName}>{separator}{timeLabel}</span>
        </>}
    </div>
}
